// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell___1ZvUN","skills":"skills___1Txa4","table":"table___PXFqT"};